import React, { useState } from "react";
import { Box, Typography, FormControlLabel, Checkbox } from "@mui/material";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import AcxMainTextField from "components/UI/AcxMainTextField";
import AcxButton from "components/UI/AcxButton";
import ErrorHandler from "./components/ErrorHandler";

interface CustomFieldDialogProps {
    isOpen: boolean;
    onClose: () => void;
    newFieldName: string;
    setNewFieldName: (value: string) => void;
    isIndexed: boolean;
    setIsIndexed: (value: boolean) => void;
    addCustomField: () => boolean;
}

const CustomFieldDialog: React.FC<CustomFieldDialogProps> = ({
    isOpen,
    onClose,
    newFieldName,
    setNewFieldName,
    isIndexed,
    setIsIndexed,
    addCustomField,
}) => {
    const [existingNameError, setExistingNameError] = useState<string>("");

    return (
        <AcxDialog
            title="Create Custom Field Name"
            isOpen={isOpen}
            onClose={() => {
                setNewFieldName("");
                setExistingNameError("");
                onClose();
            }}
            contentWidth="400px"
            dialogContentChildren={
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                    }}
                >
                    <Typography>Custom Extended Metadata Field Name</Typography>
                    <AcxMainTextField
                        id="custom-field-name"
                        fullWidth
                        placeholderText="Enter..."
                        value={newFieldName}
                        onChange={(e) => setNewFieldName(e.target.value)}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={isIndexed}
                                onChange={(e) => setIsIndexed(e.target.checked)}
                                sx={{
                                    padding: 1,
                                }}
                            />
                        }
                        label="Reportable"
                        sx={{
                            paddingRight: 2,
                            borderRadius: 1,
                            margin: 0,
                        }}
                    />
                    <ErrorHandler
                        errorMessage={
                            <Typography
                                sx={{
                                    color: "inherit",
                                    fontSize: "13px",
                                    fontWeight: 400,
                                    py: 0.5,
                                }}
                            >
                                An extended metadata field with the name{" "}
                                <strong>"{existingNameError}"</strong> already
                                exists.
                            </Typography>
                        }
                        hasError={!!existingNameError}
                        showCloseButton={false}
                    />
                </Box>
            }
        >
            <AcxButton
                color="primary"
                disabled={!newFieldName}
                onClick={() => {
                    const isFieldAdded = addCustomField();
                    if (isFieldAdded) {
                        setNewFieldName("");
                        setExistingNameError("");
                        onClose();
                    } else {
                        setExistingNameError(newFieldName);
                    }
                }}
            >
                Save
            </AcxButton>
        </AcxDialog>
    );
};

export default CustomFieldDialog;
